import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';
import 'semantic-ui-css/semantic.min.css';
import reducers from './store/reducers';
import './style/reset.css';
import './style/index.css';
import App from './components/App';

ReactDOM.render(
	<Provider store={createStore(reducers, {}, applyMiddleware(ReduxThunk))}>
		<App />
	</Provider>,
	document.querySelector('#root')
);
